<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('pressure.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time3'))">{{ $t('dailyActive.time3') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 2}" @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div id="chart-box"></div>
            <div class="legend-box">
                <div class="legend-bar1 legend-bar"></div>
                <div class="legend-bar2 legend-bar"></div>
                <div class="legend-bar3 legend-bar"></div>
                <div class="legend-bar4 legend-bar"></div>
                <div class="legend-text1 legend-text">{{$t('pressure.level0')}}</div>
                <div class="legend-text2 legend-text">{{$t('pressure.level1')}}</div>
                <div class="legend-text3 legend-text">{{$t('pressure.level2')}}</div>
                <div class="legend-text4 legend-text">{{$t('pressure.level3')}}</div>
            </div>
        </div>
        <div class="day-ratio-box" v-if="activeTime == 0">
            <van-row>
                <van-col span="12">
                    <div id="ratio-chart"></div>
                </van-col>
                <van-col span="12">
                    <div class="ratio-list">
                        <div class="list-item first-list">
                            <div class="list-item-key color1">{{$t('pressure.level3')}}</div>
                            <div class="list-item-value">{{this.mathData.avgData ? parseInt(this.pressureInfo.pressureRelaxRatio
                                * 100) + '%' : '--'}}
                            </div>
                        </div>
                        <div class="list-item">
                            <div class="list-item-key color2">{{$t('pressure.level2')}}</div>
                            <div class="list-item-value">{{this.mathData.avgData ? parseInt(this.pressureInfo.pressureNormalRatio
                                * 100) + '%' : '--'}}
                            </div>
                        </div>
                        <div class="list-item">
                            <div class="list-item-key color3">{{$t('pressure.level1')}}</div>
                            <div class="list-item-value">{{this.mathData.avgData ? parseInt(this.pressureInfo.pressureMildRatio *
                                100) + '%' : '--'}}
                            </div>
                        </div>
                        <div class="list-item last-item">
                            <div class="list-item-key color4">{{$t('pressure.level0')}}</div>
                            <div class="list-item-value">{{this.mathData.avgData ? parseInt(this.pressureInfo.pressureHighRatio *
                                100) + '%' : '--'}}
                            </div>
                        </div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="math-box">
            <van-row>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.maxData ? mathData.maxData : '--'}}</div>
                        <div class="math-text">{{$t('pressure.math0')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.minData ? mathData.minData : '--'}}</div>
                        <div class="math-text">{{$t('pressure.math1')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.avgData ? mathData.avgData : '--'}}</div>
                        <div class="math-text">{{$t('pressure.math2')}}</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="desc-box">
            <div class="desc-title">{{$t('pressure.descTitle')}}</div>
            <div class="desc-info desc-last">
                {{$t('pressure.desc0')}}
                <br>
                {{$t('pressure.desc1')}}
                <br>
                {{$t('pressure.desc2')}}
                <br>
                {{$t('pressure.desc3')}}
                <br>
                {{$t('pressure.desc4')}}
                <br>
                {{$t('pressure.desc5')}}
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'pressure',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 0,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                tNum: 0,
                wNum: 0,
                mNum: 0,
                showTimeBox: false,
                pressureInfo: {},
                mathData: {},
                myChart: null,
                pressureRatioChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('pressure.time0');
            this.startDate = getToday();
            this.endDate = getToday();
            this.time = getToday().slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.tNum <= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 2 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.tNum++;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            timeRight() {
                if (this.activeTime == 0 && this.tNum > 0) {
                    this.tNum--;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 1) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 2) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                if (this.activeTime == 0) {
                    this.startDate = getToday();
                    this.endDate = getToday();
                    this.time = getToday().slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 3) {
                    this.time = GetYear(this.yNum) + '年';
                }
                this.getData();
            },
            getData() {
                this.checkOpacity();
                this.mathData = {}
                if (this.activeTime == 0) {
                    this.$api.status.getPressure({
                        date: this.startDate
                    }).then(res => {
                        if (res.result == 1) {
                            this.mathData.maxData = res.info.pressureMax;
                            this.mathData.avgData = res.info.pressureAvg;
                            this.mathData.minData = res.info.pressureMin;
                            this.pressureInfo = res.info;
                            this.$nextTick(function () {
                                this.drawDayChart()
                                this.$forceUpdate()
                            })
                        }
                    })
                } else {
                    this.$api.status.getPressure({
                        startDate: this.startDate,
                        endDate: this.endDate
                    }).then(res => {
                        if (res.result == 1) {
                            this.pressureInfo = res.info;
                            this.mathData.maxData = res.info.maxPressure;
                            this.mathData.avgData = res.info.avgPressure;
                            this.mathData.minData = res.info.minPressure;
                            this.pressureInfo.dateArr = [];
                            this.pressureInfo.dataArr = [];
                            for (let i = 0; i < this.pressureInfo.dataPressure.length; i++) {
                                this.pressureInfo.dateArr.push(this.pressureInfo.dataPressure[i].date);
                                let color;
                                let data = this.pressureInfo.dataPressure[i].pressureAvg;
                                if (data >= 80) {
                                    color = getSkin('--chart-color-3')
                                } else if (data >= 60) {
                                    color = getSkin('--chart-color-5')
                                } else if (data >= 30) {
                                    color = getSkin('--chart-color-8')
                                } else if (data > 0) {
                                    color = getSkin('--chart-color-14')
                                } else {
                                    data = null
                                }
                                let style = {
                                    value: data,
                                    itemStyle: {
                                        color: color
                                    },
                                    emphasis: {
                                        itemStyle: {
                                            borderColor: color,
                                            borderWidth: 1.5 * this.ratio,
                                            color: 'transparent'
                                        }
                                    }
                                }
                                this.pressureInfo.dataArr.push(style);
                            }
                            this.$nextTick(function () {
                                this.drawChart()
                                this.$forceUpdate()
                            })
                        }
                    })
                }
            },
            drawDayChart() {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                interval: 35
                            },
                            axisTick: {
                                show: false
                            },
                            data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            interval: 25,
                            min: 0,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: [0, 0, 0],
                                type: 'bar',
                                symbol: 'none',
                                smooth: false,
                                barWidth: 10,
                                lineStyle: {
                                    width: 3
                                }
                            }
                        ]
                    }, true);
                } else {
                    let _this = this;
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0]-size.contentSize[0]/2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth ) {
                                    x =  cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.data ? item.data : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span></div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                interval: 35
                            },
                            axisTick: {
                                show: false
                            },
                            data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            interval: 25,
                            min: 0,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        visualMap: {
                            show: false,
                            pieces: [
                                {
                                    gt: 0,
                                    lte: 29,
                                    color: getSkin('--chart-color-14')
                                }, {
                                    gt: 29,
                                    lte: 59,
                                    color: getSkin('--chart-color-8')
                                },
                                {
                                    gt: 59,
                                    lte: 79,
                                    color: getSkin('--chart-color-5')
                                },
                                {
                                    gt: 79,
                                    lte: 100,
                                    color: getSkin('--chart-color-3')
                                }
                            ]
                        },
                        series: [
                            {
                                data: this.pressureInfo.pressureData.split(','),
                                type: 'line',
                                showSymbol: false,
                                color: getSkin('--chart-color-3'),
                                smooth: true,
                            }
                        ]
                    }, true);
                }
                this.pressureRatioChart = this.$echarts.init(document.getElementById('ratio-chart'));
                let color = [getSkin('--chart-color-14'), getSkin('--chart-color-8'), getSkin('--chart-color-5'), getSkin('--chart-color-3')];
                if (!this.mathData.avgData) {
                    color = [getSkin('--bg-color-1'), getSkin('--bg-color-1'), getSkin('--bg-color-1'), getSkin('--bg-color-1')]
                }
                // 绘制图表
                this.pressureRatioChart.setOption({
                    grid: {
                        top: 0,
                        bottom: 0
                    },
                    color: color,
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            emphasis: {
                                disabled: true,
                                focus: 'none',
                                scale: false
                            },
                            radius: ['60%', '100%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                {value: this.pressureInfo.pressureRelaxRatio, name: '放松'},
                                {value: this.pressureInfo.pressureNormalRatio, name: '正常'},
                                {value: this.pressureInfo.pressureMildRatio, name: '中等'},
                                {value: this.pressureInfo.pressureHighRatio, name: '偏高'},
                            ]
                        }
                    ]
                }, true);
            },
            drawChart() {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'Manteka',
                                fontSize: '12',
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.pressureInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            interval: 25,
                            min: 0,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: [0, 0, 0],
                                type: 'bar',
                                symbol: 'none',
                                smooth: false,
                                barWidth: 10,
                                lineStyle: {
                                    width: 3
                                }
                            }
                        ]
                    }, true);
                } else {
                    let _this = this;
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0]-size.contentSize[0]/2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth ) {
                                    x =  cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                                html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.pressureInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            interval: 25,
                            min: 0,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: this.pressureInfo.dataArr,
                                type: 'scatter',
                                symbolSize: 6 * this.ratio,
                            }
                        ]
                    }, true);
                }
            }
        },
    }
</script>

<style scoped>
    #chart-box {
        height: 198px;
        width: 100%;
    }

    .legend-box {
        width: 100%;
        height: 30px;
        position: relative;
    }

    .legend-bar {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }

    .legend-bar1 {
        background-color: var(--chart-color-3);
        left: 41px;
        top: 4px;
    }

    .legend-bar2 {
        background-color: var(--chart-color-5);
        left: 133px;
        top: 4px;
    }

    .legend-bar3 {
        background-color: var(--chart-color-8);
        left: 224px;
        top: 4px;
    }

    .legend-bar4 {
        background-color: var(--chart-color-14);
        left: 314px;
        top: 4px;
    }

    .legend-text {
        position: absolute;
        font-size: 13px;
        color: var(--text-color-2);
        top: -1px;
    }

    .legend-text1 {
        left: 54px;
    }

    .legend-text2 {
        left: 146px;
    }

    .legend-text3 {
        left: 237px;
    }

    .legend-text4 {
        left: 327px;
    }

    .day-ratio-box {
        width: 345px;
        min-height: 142px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 10px auto;
    }

    #ratio-chart {
        width: 100px;
        height: 100px;
        margin: 21px auto;
    }

    .ratio-list {
        width: 100%;
        height: 100%;
    }

    .first-list {
        margin-top: 12px;
    }

    .list-item {
        width: 137px;
        height: 27px;
        background: var(--bg-color-1);
        border-radius: 5px 5px 5px 5px;
        margin-bottom: 4px;
        margin-left: 21px;
    }

    .list-item-key {
        font-size: 13px;
        color: var(--chart-color-14);
        line-height: 27px;
        float: left;
        margin-left: 9px;
    }

    .list-item-value {
        font-size: 17px;
        color: var(--text-color-1);
        float: right;
        line-height: 27px;
        margin-right: 12px;
    }

    .last-item {
        margin-bottom: 11px;
    }

    .color1 {
        color: var(--chart-color-14);
    }

    .color2 {
        color: var(--chart-color-8);
    }

    .color3 {
        color: var(--chart-color-5);
    }

    .color4 {
        color: var(--chart-color-3);
    }

</style>



// WEBPACK FOOTER //
// src/views/status/09pressure.vue